import React from 'react'
import PropTypes from 'prop-types'
import CookieConsent from 'react-cookie-consent'

import ViewportProvider from './useViewport'
import Header from '../components/header/header'
import Footer from '../components/footer/footer'
import '../css/base.css'

const Layout = ({
  children,
  siteConfig,
  headerColor,
  navItems,
  hideFooter,
  pageBgColor,
  disableStickyNav,
}) => {
  const bgColor = pageBgColor || 'white'
  return (
    <>
      <ViewportProvider>
        <Header headerColor={headerColor} navItems={navItems} disabled={disableStickyNav} />
        <main className={`bg-${bgColor}`}>{children}</main>
        {!hideFooter && <Footer siteConfig={siteConfig}></Footer>}
        <CookieConsent
          location="bottom"
          cookieName="cookiesAccepted"
          buttonText="Lets do this!"
          buttonStyle={{ color: '#fff', backgroundColor: '#FD484D' }}
        >
          We use some third-party cookies, just so that we know you visited, because you’re
          important. We just wanted to let you know.
        </CookieConsent>
      </ViewportProvider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  siteConfig: PropTypes.object.isRequired,
}

export default Layout
